import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import { useGetChannelsByBuildingQuery } from '@/api';
import StatWidgetBox from './StatWidgetBox';
import TooltipStack from './partials/TooltipStack';
import TooltipContentContainer from './partials/TooltipContentContainer';

const WIDGET_COLOR = 'rgb(30, 136, 229)';

const ActiveCamerasChip = ({onClick, open}) => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: channels, isLoading } = useGetChannelsByBuildingQuery(activeBuildingId);
  const total = channels?.length ?? 0;

  return (
    <StatWidgetBox
      icon={<CameraAltIcon sx={{ fontSize: 16 }}/>}
      value={total}
      loading={isLoading}
      skeletonWidth={8}
      onClick={onClick}
      tooltipContent={open && <TooltipContent />}
    />
  );
};

const TooltipContent = () => {
  const { t } = useTranslation();
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: channels } = useGetChannelsByBuildingQuery(activeBuildingId);

  return (
    <TooltipContentContainer
      backgroundColor={WIDGET_COLOR}
      backgroundGradient="linear-gradient(140.9deg, rgb(144, 202, 249) -14.02%, rgba(144, 202, 249, 0) 77.58%)"
      icon={<CameraAltIcon sx={{ fontSize: 14, color: 'white' }} />}
      iconBackground="rgb(21, 101, 192)"
      iconBorder="rgb(21, 101, 192)"
      title={t('active_cameras')}
    >
      <TooltipStack 
        items={[
          { label: t('total'), value: channels?.length },
          { label: t('active'), value: channels?.length },
          { label: t('online'), value: channels?.length }
        ]}
        colorTheme="light"
        backgroundColor="rgb(255, 255, 255)"
        valueTransformFn={(value) => `${value || '-'}`}
      />
    </TooltipContentContainer>
  );
}
export default ActiveCamerasChip;
